/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import { EventsList } from './models/events';
import Component from 'can/component/component';
import template from './tv-schedule.stache';
import _ from 'lodash';
import dayjs from 'dayjs';

Component.extend({
    tag: 'tv-schedule',
    template: template,
    viewModel: {
        events: [],
        define: {
            displayedEvents: {
                Type: EventsList,
                Value: EventsList,
            },
        },
    },
    events: {
        init: function() {
            const currentDate = dayjs(
                dayjs()
                    .tz('America/Chicago')
                    .format('YYYY-MM-DD'),
                'YYYY-MM-DD',
            ).valueOf();
            const sortedEvents = (this.viewModel.attr('events') || []).sort(
                (a, b) => {
                    let date1 = dayjs(a.broadcastStart).valueOf();
                    let date2 = dayjs(b.broadcastStart).valueOf();

                    if (date1 === date2) {
                        return 0;
                    }

                    return date1 > date2 ? 1 : -1;
                },
            );
            const previousEvents = {};
            const currentEvents = [];
            const upcomingEvents = {};

            sortedEvents.forEach((event) => {
                const startDate = this.getOriginalDayTimestamp(
                    event.broadcastStart,
                );

                if (startDate < currentDate) {
                    if (!previousEvents[startDate]) {
                        previousEvents[startDate] = [];
                    }
                    previousEvents[startDate].push(event);
                }
                if (startDate === currentDate) {
                    currentEvents.push(event);
                }
                if (startDate > currentDate) {
                    if (!upcomingEvents[startDate]) {
                        upcomingEvents[startDate] = [];
                    }
                    upcomingEvents[startDate].push(event);
                }
            });

            if (currentEvents.length > 0) {
                this.viewModel.attr(
                    'date',
                    this.getOriginalFormattedDate(
                        currentEvents[0].broadcastStart,
                    ),
                );
                this.viewModel.attr('displayedEvents', currentEvents);
            } else if (_.keys(upcomingEvents).length > 0) {
                const activeEvents = _.values(upcomingEvents)[0];

                this.viewModel.attr(
                    'date',
                    this.getOriginalFormattedDate(
                        activeEvents[0].broadcastStart,
                    ),
                );
                this.viewModel.attr('displayedEvents', activeEvents);
            } else if (_.keys(previousEvents).length > 0) {
                const activeEvents = _.last(_.values(previousEvents));

                this.viewModel.attr(
                    'date',
                    this.getOriginalFormattedDate(
                        activeEvents[0].broadcastStart,
                    ),
                );
                this.viewModel.attr('displayedEvents', activeEvents);
            }
        },

        getOriginalFormattedDate(date) {
            return dayjs(date, 'YYYY-MM-DD').format('dddd, MMMM D');
        },

        getOriginalDayTimestamp(date) {
            return dayjs(date, 'YYYY-MM-DD').valueOf();
        },
    },
});
